import axios from 'axios'

console.log(process.env.NODE_ENV)
const client = axios.create({
  baseURL: '',
  json: true
  // withCredentials: true
})

export default {
  async execute (method, resource, data, params) {
    return client({
      method,
      url: resource,
      params: params,
      data
    }).then(req => {
      return req.data
    })
  },
  getMarkdown () {
    return this.execute('get', './static/data/skill_tree_public.md')
  }
}



// WEBPACK FOOTER //
// ./src/api.js